import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jifelseif(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) { 
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
  <Sides/>
  <Helmet>
 
 <title>Master the Art of Java If Else If: A Beginner's Tutorial Guide by CodeExampler</title>
<meta name="description" content="JLearn how to use the Java if else if statement with CodeExampler's beginner tutorial. Create multiple conditions and execute code blocks based on logical expressions." />
<meta name="keywords" content="Java if else if Example,java if else if program Java else if statement,java if else if ladder, coding for beginners, CodeExampler" />
<link rel="canonical" href="https://www.codeexampler.com/java-if-else-if" />
</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Java if else if</h1>
    <div className="first">
        <a href="/java-if-else">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-conditional-operator">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


<h2 className="headings">The Syntax for Java If Else If:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        

  {"\n"}
  <span className="qwerty-5">if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">condition</span>
        <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&#123; </span>

  {"\n"}
  
        <span className="qwerty-4">&nbsp;&nbsp;Statement;</span>
      {"\n"}
  <span className="qwerty-3">&#125; </span>

  {"\n"}


  <span className="qwerty-5">else if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">condition</span>
        <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&#123; </span>

  {"\n"}
  
        <span className="qwerty-4">&nbsp;&nbsp;Statement;</span>
      {"\n"}
  <span className="qwerty-3">&#125; </span>

  {"\n"}
  <span className="qwerty-5">else </span>
  {"\n"}
  <span className="qwerty-3">&#123; </span>

  {"\n"}
  
        <span className="qwerty-4">&nbsp;&nbsp;Statement;</span>
      {"\n"}
  <span className="qwerty-3">&#125; </span>

  {"\n"}
 </code>
      </pre>        
    </div>

<h2 className="mt-4 mh2">Java if else if Example</h2>
<h3 className="mt-4 mh3">If else if is used more than two options:
</h3>



<h2 className="headings">Q-Write a Program to Maximum Between three no in Java if else if Statement Example</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> ifelse_if</span>
          <span className="qwerty-2"> {` // class is a keyword`}</span>
         
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>          
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8"> ,</span>
    <span className="qwerty-4">b</span>
    <span className="qwerty-8"> ,</span>
    <span className="qwerty-4">c;</span>
 
  {"\n"}
  <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;a</span>
    <span className="qwerty-8"> = </span>
    <span className="qwerty-1">20;</span>
    <span className="qwerty-4">b</span>
    <span className="qwerty-8"> = </span>
    <span className="qwerty-1">40;</span>
    <span className="qwerty-4">c</span>
    <span className="qwerty-8"> = </span>
    <span className="qwerty-1">60;</span>

  {"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty-8">&#62;</span> 
        <span className="qwerty-4">b</span> 
        <span className="qwerty-8"> && </span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty-8">&#62;</span> 
        <span className="qwerty-4">c</span> 
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"a"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>

  {"\n"}


  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;else if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">b</span> 
        <span className="qwerty-8">&#62;</span> 
        <span className="qwerty-4">a</span> 
        <span className="qwerty-8"> && </span>
        <span className="qwerty-4">b</span> 
        <span className="qwerty-8">&#62;</span> 
        <span className="qwerty-4">c</span> 
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"b"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>

  {"\n"}

  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;else </span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"c"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>

  {"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
  


 
 



{"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;c </span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>


<h2 className="headings">Q-Write a Program positive, negative, zero in Java if else if Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> Basic_example</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>          
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
    <span className="qwerty-4">i</span>
    <span className="qwerty-8"> = </span>
    <span className="qwerty-1">45;</span>
 
  {"\n"}

  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
        <span className="qwerty-8">&#60;</span> 
        <span className="qwerty-1">0</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"negative"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>

  {"\n"}


  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;else if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span> 
        <span className="qwerty-8">&#62;</span> 
        <span className="qwerty-1">0</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"positive"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>

  {"\n"}

  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;else </span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"zero"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>

  {"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
  


 
 



{"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;positive </span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>


<h2 className="headings">Q-Write a Program to input the age and print appropriate message according to a full condition in Java if else if Example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> Basic_example</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>          
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
    <span className="qwerty-4">age</span>
    <span className="qwerty-8"> = </span>
    <span className="qwerty-1">48;</span>
 
  {"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">age</span>
        <span className="qwerty-8">&#62;</span>  
        <span className="qwerty-8">=</span>
        <span className="qwerty-1">60</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"old"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>

  {"\n"}

  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;else if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">age</span>
        <span className="qwerty-8">&#62;</span>  
        <span className="qwerty-8">=</span>
        <span className="qwerty-1">40</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"not young, not old"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>

  {"\n"}


  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;else if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">age</span>
        <span className="qwerty-8">&#62;</span>  
        <span className="qwerty-8">=</span>
        <span className="qwerty-1">20</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"young"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>

  {"\n"}

  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;else </span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"child"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>

  {"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
  
{"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;not young, not old </span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>

  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/java-if-else">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-conditional-operator">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Jifelseif;